import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { SmallArrowUpRight } from "components/icons/SmallArrowUpRight";
import ThreeDots from "static/images/ThreeDots.svg";

export const Form1099VendorOptions = ({
  redirectToVendor,
  exportVendors,
}: {
  redirectToVendor?: () => void;
  exportVendors?: () => void;
}) => (
  <Dropdown.Root>
    <Dropdown.Trigger asChild>
      <div>
        <Button size="xsmall" customType="icon">
          <img src={ThreeDots} alt="Action" className="t-select-none" />
        </Button>
      </div>
    </Dropdown.Trigger>
    <Dropdown.Portal>
      <Dropdown.Content
        className="!t-w-40 !t-min-w-40"
        sideOffset={4}
        align="end"
        side="bottom"
      >
        {redirectToVendor && (
          <Dropdown.Item onSelect={redirectToVendor}>
            View all vendors <SmallArrowUpRight className="t-size-2" />
          </Dropdown.Item>
        )}
        {exportVendors && (
          <Dropdown.Item onSelect={exportVendors}>Export</Dropdown.Item>
        )}
      </Dropdown.Content>
    </Dropdown.Portal>
  </Dropdown.Root>
);
